import {NavigationModelService} from "./service/NavigationModelService";

import Components from "./components";

const rootDir = "app/nav";

export default angular.module("tfApp.nav", [Components(rootDir)])
                      .service(NavigationModelService.id, NavigationModelService)
                      .name;
